<div class="container m-auto px-2 sm:px-4">
  <p-messages [(value)]="msgs" [enableService]="false" [escape]="false"></p-messages>
</div>
